import { IBiller } from '../types/biller';
import { postEmail, postEmailV2, postPayableEmail, postSms, postSmsV2, postPayableSms } from "api/IamApi/entities/ezpay";


export const isEmail = (val: string) => {
  const regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return regEmail.test(val);
};

export const postEmailWithInstanceId = async (biller: IBiller, emailAddress: string): Promise<boolean> => {
  if (biller?.instanceId != null) {
    try {
      const axiosResponse = await postEmail(
        biller?.instanceId,
        biller?.clientId,
        emailAddress
      );
      if (axiosResponse.status === 200) {
        return true;
      }
    } catch (error) {
      return false;
    }

  }
  return false;
}

export const postEmailWithSpaceKrn = async (biller: IBiller, emailAddress: string): Promise<boolean> => {
  if (biller?.spaceKrn != null) {
    try {
      const axiosResponse = await postEmailV2(
        biller?.spaceKrn,
        biller?.clientId,
        emailAddress
      );
      if (axiosResponse.status === 200) {
        return true;
      }
    } catch (error) {
      return false;
    }

  }
  return false;
}

export const postPayableEmailWithSpaceKrn = async (biller: IBiller, emailAddress: string): Promise<boolean> => {
  if (biller?.spaceKrn != null) {
    try {
      const axiosResponse = await postPayableEmail(
        biller?.spaceKrn,
        biller?.clientId,
        emailAddress
      );
      if (axiosResponse.status === 200) {
        return true;
      }
    } catch (error) {
      return false;
    }

  }
  return false;
}

export const isPhone = (phone: string) => {
  if (phone !== undefined && phone.length > 0) {
    if (phone.length !== 10 && phone.length !== 11) {
      return false;
    }
    return true;
  } else {
    return false;
  }
};

export const postSmslWithInstanceId = async (biller: IBiller, numPhone: string): Promise<boolean> => {
  if (biller?.instanceId != null) {
    try {
      const axiosResponse = await postSms(
        biller?.instanceId,
        biller?.clientId,
        numPhone
      );
      if (axiosResponse.status === 200) {
        return true;
      }
    } catch (error) {
      return false;
    }

  }
  return false;
}

export const postSmslWithSpaceKrn = async (biller: IBiller, numPhone: string): Promise<boolean> => {
  if (biller?.spaceKrn != null) {
    try {
      const axiosResponse = await postSmsV2(
        biller?.spaceKrn,
        biller?.clientId,
        numPhone
      );
      if (axiosResponse.status === 200) {
        return true;
      }
    } catch (error) {
      return false;

    }

  }
  return false;
}

export const postPayableSmsWithSpaceKrn = async (biller: IBiller, numPhone: string): Promise<boolean> => {
  if (biller?.spaceKrn != null) {
    try {
      const axiosResponse = await postPayableSms(
        biller?.spaceKrn,
        biller?.clientId,
        numPhone
      );
      if (axiosResponse.status === 200) {
        return true;
      }
    } catch (error) {
      return false;

    }

  }
  return false;
}
